/**
 * Placeholders for panels whose backend lands in a later phase. They render a
 * clear "what this will be / why it's not live yet" state rather than fake data,
 * so the console never lies about what's wired.
 */
import { Banner, Stub } from '../ui';

export function UnifiedStub({ kind }: { kind: 'vehicles' | 'cross' }) {
  const title = kind === 'vehicles' ? 'Unified vehicle tree' : 'Unified cross lookup';
  const body =
    kind === 'vehicles' ? (
      <>
        One brand → model → version browser that merges the Kromeda and TecDoc trees via a mapping table
        (Kromeda <span className="mono">marca/modello/versione</span> ↔ TecDoc{' '}
        <span className="mono">manuId/modelId/ktype</span>). Until then, browse each source's native tree under its own
        section — those are live.
      </>
    ) : (
      <>
        Enter any code → identify the product → cross it across every source. This now lives in <b>Search</b>, which
        does exactly that.
      </>
    );
  return (
    <>
      <Banner icon="◇">Unifying the two vehicle trees needs a mapping between them, which does not exist yet.</Banner>
      <Stub title={title}>{body}</Stub>
    </>
  );
}
